module.exports = __webpack_public_path__ + "static/who-4241b43e78e72eb79e0f3bdc9e5e736f.jpg";